/* eslint-disable no-useless-escape */
import { createElement } from 'react'

import Helmet from 'react-helmet'
import { useLocation } from 'react-router'
import serialize from 'serialize-javascript'

import { Page } from '@tribeplatform/gql-client/types'

export const PageMeta = ({ page }: { page: Page }) => {
  const seoDetail = page?.seoDetail
  const { pathname } = useLocation()
  if (!seoDetail) {
    return null
  }

  const { additionalMeta, title, description, jsonld } = seoDetail
  let serializedJsonld
  try {
    if (typeof jsonld === 'string') {
      serializedJsonld = serialize(JSON.parse(jsonld), { isJSON: true })
    }
  } catch (e) {
    serializedJsonld = undefined
  }

  return (
    <Helmet
      bodyAttributes={{
        'data-path': pathname?.replace(/[^\_\-a-zA-Z0-9\/]/g, ''),
        'data-matched-route': `/${page?.space?.address?.path || ''}`,
      }}
    >
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {/* TODO: find a better key for additionalMeta tags */}
      {/* We have to use array index for now */}
      {additionalMeta?.map((tag, index) => {
        try {
          return createElement(tag.type.toLowerCase().trim(), {
            ...tag.properties.reduce((props, keyValue) => {
              return {
                ...props,
                [keyValue.key]: keyValue.value,
              }
            }, {}),
            key: index,
          })
        } catch (error) {
          logger.error('error parsing additional meta tags', { tag, error })
        }
        return null
      })}
      {serializedJsonld && (
        <script type="application/ld+json">{serializedJsonld}</script>
      )}
    </Helmet>
  )
}
